/* unplugin-vue-components disabled */import script from "./ch1.vue?vue&type=script&setup=true&lang=ts"
export * from "./ch1.vue?vue&type=script&setup=true&lang=ts"

import "./ch1.vue?vue&type=style&index=0&id=36251994&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36251994"]])

export default __exports__